// extracted by mini-css-extract-plugin
export var link = "storeLinks-module--link--MAD2U";
export var store = "storeLinks-module--store---zAoI";